let token: string | null = null;

export const AuthorizationMiddleware = {
  get token() {
    return token;
  },

  setToken(value: string | null) {
    token = value;
  },

  getHeader(): Record<string, string> {
    if (!token) return {};
    return { 'accounts-access-token': token };
  },
};
